import {CreatePaymentInput, PaymentMethods} from 'api/generated';
import {Moment} from 'moment-timezone';

export type PayByLinkFormValues = CreatePaymentInput & {
  manualCapture: boolean;
  hasBillingDetails: boolean;
  hasShippingDetails: boolean;
  expireAt: Moment;
};

export const PAY_METHODS_FULL_INFO_REQUIRED = [
  PaymentMethods.MULTIBANCO,
  PaymentMethods.SEPA,
  PaymentMethods.KLARNA
];

export const PAY_METHODS_MANUAL_CAPTURE_ENABLED = [PaymentMethods.CARD, PaymentMethods.PAYPAL];
